import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoginComponent from 'components/modules/Login';
import PinRecovery from 'components/modules/Login/components/PinRecovery';

const AppRoutes = () => {
  const { app } = useSelector((state) => state.login);

  return (
    <Routes>
      <Route path="/login" element={<LoginComponent />} />
      <Route path="/pin-recovery" element={<PinRecovery />} />
      <Route path={'/'} element={<Navigate to={`/login?app=${app}`} />} />
    </Routes>
  );
};

AppRoutes.propTypes = {
  app: PropTypes.string,
  session: PropTypes.string,
  redirectURL: PropTypes.string
};

export default AppRoutes;
